export type DeviceBatteryColor = "success" | "warning" | "error";

export type DeviceBatteryIcon =
  | "battery0"
  | "battery20"
  | "battery50"
  | "battery80"
  | "batteryFull"
  | "power";

interface BatteryDevice {
  batteryPercent?: number;
  operatingSystemType?: string;
  type: string;
}

export interface DeviceBatteryDisplay {
  color: DeviceBatteryColor;
  icon: DeviceBatteryIcon;
  isPluggedIn: boolean;
}

/**
 * Returns the shared battery presentation state used by device management views.
 * Android devices reporting 50% or 55% in their fixed-install roles are on wall power.
 */
export const getDeviceBatteryDisplay = (device: BatteryDevice): DeviceBatteryDisplay | null => {
  const batteryPercent = device.batteryPercent;

  if (batteryPercent === undefined || batteryPercent < 0) {
    return null;
  }

  const isPluggedIn =
    [50, 55].includes(batteryPercent) &&
    device.operatingSystemType?.toUpperCase() === "ANDROID" &&
    ["SHOPPER", "ASSIST", "CENTRAL", "SURFACE"].includes(device.type.toUpperCase());

  if (isPluggedIn) {
    return { color: "success", icon: "power", isPluggedIn: true };
  }

  const icon =
    batteryPercent === 0
      ? "battery0"
      : batteryPercent <= 24
        ? "battery20"
        : batteryPercent <= 59
          ? "battery50"
          : batteryPercent < 90
            ? "battery80"
            : "batteryFull";
  const color = batteryPercent <= 20 ? "error" : batteryPercent <= 50 ? "warning" : "success";

  return { color, icon, isPluggedIn: false };
};
